const Input = {
  baseStyle: {},
  variants: {},
  defaultProps: {
    focusBorderColor: "#01FFB0",
  },
};

export { Input };
